module.exports = __webpack_public_path__ + "img/bs2.b95c4b3c.jpg";